var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFull = function SvgStarFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    d: "M7.552 1.375a.5.5 0 0 1 .896 0l1.787 3.62a.5.5 0 0 0 .376.273l3.995.58a.5.5 0 0 1 .277.854l-2.89 2.817a.5.5 0 0 0-.144.443l.682 3.978a.5.5 0 0 1-.726.527L8.234 12.59a.5.5 0 0 0-.466 0l-3.573 1.878a.5.5 0 0 1-.725-.527l.682-3.978a.5.5 0 0 0-.143-.443L1.117 6.702a.5.5 0 0 1 .277-.853l3.995-.58a.5.5 0 0 0 .376-.274z"
  })));
};
export default SvgStarFull;